module.exports = __webpack_public_path__ + "static/Macbook@2x-a16fa458b16bbffb57eb2ad5fecf054a.png";